import { render, staticRenderFns } from "./TrailPriceField.vue?vue&type=template&id=53823338"
import script from "./TrailPriceField.vue?vue&type=script&lang=js"
export * from "./TrailPriceField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports